import { t } from "../i18n/index.ts";

/** Classic plump heart (rounded lobes, soft point) in a 24×24 viewBox. */
const HEART_PATH_D =
  "M12 20.85c-.28 0-.55-.09-.76-.26C6.02 16.28 2.75 13.32 2.75 9.5 2.75 6.58 5.08 4.25 8 4.25c1.62 0 3.14.78 4 1.98.86-1.2 2.38-1.98 4-1.98 2.92 0 5.25 2.33 5.25 5.25 0 3.82-3.27 6.78-8.49 11.09-.21.17-.48.26-.76.26z";

export const QUEST_SAVE_HEART_ICON_CLASS = "quest-save-heart-icon";

const SAVED_STATE_KEY = "data-saved-state";

function questSaveHeartSvg(saved: boolean): string {
  if (saved) {
    return `<svg class="${QUEST_SAVE_HEART_ICON_CLASS}" viewBox="0 0 24 24" width="27" height="27" aria-hidden="true" focusable="false"><path d="${HEART_PATH_D}" fill="currentColor"/></svg>`;
  }
  return `<svg class="${QUEST_SAVE_HEART_ICON_CLASS}" viewBox="0 0 24 24" width="27" height="27" aria-hidden="true" focusable="false"><path d="${HEART_PATH_D}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}

function playSaveHeartPop(btn: HTMLButtonElement): void {
  btn.classList.remove("is-popping");
  void btn.offsetWidth;
  btn.classList.add("is-popping");
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    btn.classList.remove("is-popping");
    return;
  }
  const icon = btn.querySelector(`.${QUEST_SAVE_HEART_ICON_CLASS}`);
  if (!icon) return;
  const onEnd = (ev: Event) => {
    if (ev.target !== icon) return;
    icon.removeEventListener("animationend", onEnd);
    btn.classList.remove("is-popping");
  };
  icon.addEventListener("animationend", onEnd);
}

/** Paint the quest save / unsave heart (same control on the quest page and home detail panel). */
export function paintQuestSaveHeart(btn: HTMLButtonElement, saved: boolean, busy = false): void {
  const prev = btn.getAttribute(SAVED_STATE_KEY);
  const prevSaved = prev === "1";
  const nextKey = saved ? "1" : "0";
  btn.setAttribute(SAVED_STATE_KEY, nextKey);
  btn.setAttribute("aria-pressed", String(saved));
  btn.setAttribute("aria-label", saved ? t("quest.unsaveQuest") : t("quest.saveQuest"));
  btn.innerHTML = questSaveHeartSvg(saved);
  btn.classList.toggle("is-saved", saved);
  btn.disabled = busy;
  if (prev !== null && prevSaved !== saved) playSaveHeartPop(btn);
}

export function questSaveHeartEnabled(status: string): boolean {
  return status === "active" || status === "hidden";
}
